module.exports = __webpack_public_path__ + "static/img/WechatIMG320.376357a6.jpeg";